import type { PendingPayment } from "../checkoutTypes";
import type { PaymentAmountSelection } from "../amountSelection";
import type { DispatchProPaymentSummary, DispatchProTemporaryCard } from "../payment";
import { shouldApplySurcharge } from "../surcharge";

export const finixScriptUrl = "https://js.finix.com/v/1/finix.js";
export const finixPaymentFormId = "dp-embedded-form";

export type FinixForm = {
  submit: (
    environment: "sandbox" | "live",
    applicationId: string,
    callback: (error: unknown, response?: { data?: { id?: string } }) => void,
  ) => void;
};

export type FinixFormOptions = {
  onUpdate: (_state: unknown, _binInformation: unknown, formHasErrors: boolean) => void;
  showAddress: boolean;
  hideFields: string[];
  requiredFields: string[];
  labels: Record<string, string>;
};

export const finixCardTokenFormOptions = {
  showAddress: true,
  hideFields: [
    "address_state",
    "address_country",
    "address_city",
    "address_region",
    "address_line2",
    "address_line1",
  ],
  requiredFields: ["address_postal_code"],
  labels: {
    address_postal_code: "Billing ZIP code",
  },
} satisfies Omit<FinixFormOptions, "onUpdate">;

export function createFinixPendingPayment({
  customerId,
  fraudSessionId,
  invoiceId,
  payment,
  paymentAmount,
  tempCard,
}: {
  customerId: string;
  fraudSessionId: string;
  invoiceId?: string;
  payment: DispatchProPaymentSummary;
  paymentAmount: PaymentAmountSelection;
  tempCard: DispatchProTemporaryCard;
}): PendingPayment {
  return {
    request: {
      customerId,
      invoiceId,
      amount: paymentAmount.amount,
      applySurcharge: shouldApplySurcharge(payment.surchargePercentage, tempCard.canSurcharge),
      card: {
        id: tempCard.id,
        token: fraudSessionId,
      },
    },
    card: tempCard,
  };
}
